import React, { useState } from "react";

const FormData = ({ onSubmit }) => {
  const [formdata, setFormdata] = useState({
    name: "",
    mobileNumber: "",
    email: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;
    if (name === "mobileNumber") {
      if (/^\d{0,10}$/.test(value)) {
        newValue = value;
      } else {
        return;
      }
    }
    setFormdata({
      ...formdata,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formdata);
  };

  return (
    <>
      <div
        style={{
          fontFamily: "Ballega",
          maxHeight: "90vh",
          overflowY: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
        className="overflow-y-auto p-4 sm:p-24 lg:p-44 h-[30rem] md:h-[40rem]"
      >
        <div className="bg-emerald-600 p-4 md:px-6 md:py-10 flex flex-col gap-6 rounded-xl">
          <h4 className="md:text-3xl text-white text-center">
            Enter your Details
          </h4>
          <form
            onSubmit={handleSubmit}
            style={{
              fontFamily: "Barlow Condensed",
            }}
          >
            <input
              type="text"
              name="name"
              className="arial text-lg font-bold placeholder-white border border-2 border-gray-300 w-full rounded-md p-2 my-3 bg-emerald-600 outline-none"
              placeholder="Enter your name"
              value={formdata.name}
              onChange={handleInputChange}
              required
            />
            <input
              type="number"
              name="mobileNumber"
              className="arial text-lg font-bold placeholder-white border border-2 border-gray-300 w-full rounded-md p-2 my-3 bg-emerald-600 outline-none"
              placeholder="Enter Phone Number"
              pattern="[0-9]{10}"
              maxLength="10"
              value={formdata.mobileNumber}
              min="0"
              onChange={handleInputChange}
              required
            />
            <input
              type="email"
              name="email"
              className="arial text-lg font-bold placeholder-white border border-2 border-gray-300 w-full rounded-md p-2 my-3 bg-emerald-600 outline-none"
              placeholder="Enter e-mail"
              value={formdata.email}
              onChange={handleInputChange}
            />
            <div className="flex justify-center">
              <button
                type="submit"
                className="px-4 py-2 mt-4 text-white bg-sky-600 hover:bg-sky-500 hover:text-black hover:font-bold border border-2 border-gray-300"
              >
                Submit Your Details
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default FormData;
